import {addClassToElements, removeClassFromElements} from "../helper.js";

export function handleTabActivation(clickedTabElement, tabSliderElement, Collapse) {
  if (clickedTabElement && clickedTabElement.classList.contains('active')) return;

  const tabElements = tabSliderElement.querySelectorAll('.tab'),
    tabImageElements = tabSliderElement.querySelectorAll('.tab-image'),
    recentTab = tabSliderElement.querySelector('.tab.active') || tabElements[0],
    recentTabImage = tabSliderElement.querySelector('.tab-image.active') || tabImageElements[0];

  let upcomingTab = recentTab.nextElementSibling || tabElements[0],
    upcomingTabImage = recentTabImage.nextElementSibling || tabImageElements[0];

  if (clickedTabElement) {
    upcomingTab = clickedTabElement;
    upcomingTabImage = Array.from(tabImageElements).find(tabImageElement => {
      return tabImageElement.getAttribute('data-tab') === upcomingTab.getAttribute('data-tab')
    });
  }

  const nextTab = upcomingTab.nextElementSibling || tabElements[0],
    nextTabImage = upcomingTabImage.nextElementSibling || tabImageElements[0];


  Collapse.getOrCreateInstance(recentTab.querySelector('.collapse')).hide();
  Collapse.getOrCreateInstance(upcomingTab.querySelector('.collapse')).show();

  removeClassFromElements('active', [recentTab, recentTabImage]);
  removeClassFromElements('next', [upcomingTab, upcomingTabImage]);
  addClassToElements('active', [upcomingTab, upcomingTabImage]);
  addClassToElements('next', [nextTab, nextTabImage]);
}

export function autoplayInterval(tabSliderElement, Collapse) {
  const tabSliderStyles = getComputedStyle(tabSliderElement),
    intervalDuration = Number(tabSliderStyles.getPropertyValue('--slider-duration').replace('ms', ''));
  return setInterval(() => handleTabActivation(null, tabSliderElement, Collapse), intervalDuration);
}
